import api from './api';

function normEmail(s) { return String(s || '').trim().toLowerCase(); }
function normPhone(s) {
  let p = String(s || '').replace(/[^\d]/g, '');
  if (p.startsWith('92')) p = '0' + p.slice(2);
  if (p && !p.startsWith('0')) p = '0' + p;
  return p;
}

function normRec(r) {
  if (!r || typeof r !== 'object') return null;
  const name = String(r.name || r.full_name || 'Subscriber').trim() || 'Subscriber';
  const email = normEmail(r.email);
  const phone = normPhone(r.phone || r.mobile || r.whatsapp || '');
  const id = String(r.id || '');
  return {
    ...r,
    id,
    name,
    email,
    phone,
    source: r.source || 'Website',
    status: r.status || 'subscribed',
    subscribed: r.status !== 'unsubscribed',
    created_at: r.created_at || new Date().toISOString(),
    updated_at: r.updated_at || new Date().toISOString(),
  };
}

export const newsletterApi = {
  subscribe: async (payload) => {
    const body = {
      name: payload?.name || 'Subscriber',
      email: normEmail(payload?.email),
      phone: normPhone(payload?.phone || ''),
      source: payload?.source || 'Website',
    };
    if (!body.email) return { ok: false, error: 'Email is required' };
    const r = await api.post('/newsletter/subscribe', body);
    const data = r?.data || {};
    const rec = normRec(data.data || data.subscriber || data);
    return { ok: true, record: rec, duplicate: !!data.duplicate, stored: 'api' };
  },

  list: async () => {
    const r = await api.get('/newsletter', { params: { per_page: 500 } });
    const body = r?.data || {};
    const raw = body.data || body.subscribers || [];
    const merged = (Array.isArray(raw) ? raw : []).map(normRec).filter(Boolean);
    merged.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
    return { ok: true, data: { subscribers: merged, data: merged, length: merged.length } };
  },

  stats: async () => {
    try {
      const { data } = await newsletterApi.list();
      const list = data.subscribers || [];
      const today = new Date(); today.setHours(0, 0, 0, 0);
      const todayTs = today.getTime();
      const ONE_DAY = 86400000;
      const last7 = todayTs - 6 * ONE_DAY;
      return {
        total: list.length,
        active: list.filter((s) => s.status !== 'unsubscribed').length,
        today: list.filter((s) => new Date(s.created_at || 0).getTime() >= todayTs).length,
        last7: list.filter((s) => new Date(s.created_at || 0).getTime() >= last7).length,
        withEmail: list.filter((s) => s.email).length,
        withPhone: list.filter((s) => s.phone).length,
        uniqueEmails: new Set(list.map((s) => s.email).filter(Boolean)).size,
        uniquePhones: new Set(list.map((s) => s.phone).filter(Boolean)).size,
      };
    } catch {
      return { total: 0, active: 0, today: 0, last7: 0, withEmail: 0, withPhone: 0, uniqueEmails: 0, uniquePhones: 0 };
    }
  },

  unsubscribe: async (idOrEmail) => {
    await api.post('/newsletter/unsubscribe', { id: idOrEmail, email: normEmail(idOrEmail) });
    return { ok: true };
  },

  remove: async (id) => {
    await api.delete(`/newsletter/${id}`);
    return { ok: true };
  },

  clear: async () => {
    await api.post('/newsletter/clear');
    return { ok: true };
  },

  syncSubscribers: async () => {
    const r = await api.post('/newsletter/sync-subscribers');
    return r?.data || { ok: true };
  },

  exportCSV: async () => {
    const { data } = await newsletterApi.list();
    const list = data.subscribers || [];
    const rows = [['Name', 'Email', 'Phone', 'Source', 'Status', 'Subscribed On']];
    list.forEach((s) => rows.push([
      `"${(s.name || '').replace(/"/g, '""')}"`,
      s.email || '',
      s.phone || '',
      s.source || 'Website',
      s.status === 'unsubscribed' ? 'Unsubscribed' : 'Subscribed',
      new Date(s.created_at || 0).toLocaleString(),
    ]));
    const csv = '\uFEFF' + rows.map((r) => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'Flare-Newsletter-Subscribers.csv'; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
    return list.length;
  },
};

export default newsletterApi;
